import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import ProveClaim from '../../Components/ProveClaim/ProveClaim'
export default function VerifyHospital() {
  return (
    <Box sx={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"space-between",width:"100vw",minHeight:"100vh"}}>
        <ProveClaim keys={["id","name","father's_name","mother's_name","date_of_birth","nationality"]}/>
    
    </Box>
  )
}